import { render, staticRenderFns } from "./MemberCoupon.vue?vue&type=template&id=24f60f68&scoped=true&"
import script from "./MemberCoupon.vue?vue&type=script&lang=js&"
export * from "./MemberCoupon.vue?vue&type=script&lang=js&"
import style0 from "./MemberCoupon.vue?vue&type=style&index=0&id=24f60f68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f60f68",
  null
  
)

export default component.exports